import type { AuditAction } from '@/types/audit'

/** Verb phrase that follows the actor's name — written so the whole line reads as a plain Romanian sentence. */
export const AUDIT_ACTION_VERBS: Record<AuditAction, string> = {
  'customer.created': 'a adăugat clientul',
  'customer.updated': 'a modificat datele clientului',
  'customer.archived': 'a arhivat clientul',
  'customers.imported': 'a importat o listă de clienți',
  'consent.requested': 'a trimis acordul către',
  'consent.recorded': 'a semnat acordul de comunicare',
  'consent.revoked': 'a renunțat la comunicări',
  'campaign.sent': 'a trimis campania',
  'campaign.scheduled': 'a programat campania',
  'template.created': 'a creat șablonul',
  'template.updated': 'a modificat șablonul',
  'segment.created': 'a creat grupul de clienți',
  'segment.deleted': 'a șters grupul de clienți',
  'team.invited': 'a invitat în echipă pe',
  'team.role_changed': 'a schimbat rolul pentru',
  'team.removed': 'a eliminat din echipă pe',
  'roles.updated': 'a modificat permisiunile rolului',
  'settings.updated': 'a modificat setările companiei',
  'integration.updated': 'a modificat integrarea',
  'integration.connected': 'a conectat integrarea',
  'integration.test_failed': 'a testat fără succes integrarea',
  'integration.disconnected': 'a deconectat integrarea',
  'onboarding.completed': 'a finalizat configurarea inițială',
  'automation.created': 'a creat automatizarea',
  'automation.updated': 'a modificat automatizarea',
  'automation.deleted': 'a șters automatizarea',
  'automation.enabled': 'a activat automatizarea',
  'automation.disabled': 'a dezactivat automatizarea',
  'billing.plan_changed': 'a schimbat planul de abonament',
  'security.two_factor_enabled': 'a activat verificarea în doi pași',
  'security.two_factor_disabled': 'a dezactivat verificarea în doi pași',
  'security.recovery_codes_regenerated': 'a generat coduri de rezervă noi',
}

export interface AuditCategory {
  key: string
  label: string
  actions: AuditAction[]
}

/** Filter groups in the journal — coarse, in the user's vocabulary, not one option per action. */
export const AUDIT_CATEGORIES: AuditCategory[] = [
  { key: 'customers', label: 'Clienți', actions: ['customer.created', 'customer.updated', 'customer.archived', 'customers.imported'] },
  { key: 'consents', label: 'Acorduri', actions: ['consent.requested', 'consent.recorded', 'consent.revoked'] },
  { key: 'campaigns', label: 'Campanii și șabloane', actions: ['campaign.sent', 'campaign.scheduled', 'template.created', 'template.updated', 'segment.created', 'segment.deleted', 'automation.created', 'automation.updated', 'automation.deleted', 'automation.enabled', 'automation.disabled'] },
  { key: 'team', label: 'Echipă și roluri', actions: ['team.invited', 'team.role_changed', 'team.removed', 'roles.updated'] },
  { key: 'settings', label: 'Setări și integrări', actions: ['settings.updated', 'integration.updated', 'integration.connected', 'integration.disconnected', 'integration.test_failed', 'onboarding.completed', 'billing.plan_changed', 'security.two_factor_enabled', 'security.two_factor_disabled', 'security.recovery_codes_regenerated'] },
]
